export const useDailyQuotaLeaveTypes = () => {
    return ['SICK_LEAVE', 'PERMISSION', 'PATERNAL', 'MATERNAL', 'MATERNAL_ASSISTANCE']
}